module.exports = __webpack_public_path__ + "static/media/free_training.26a8e5c1.svg";